import(/* webpackMode: "eager" */ "/opt/build/repo/node_modules/.pnpm/next@16.2.12_@babel+core@7.29.7_supports-color@10.2.2__@playwright+test@1.59.1_@types+n_ca915961cbc9f1ffe1ddb04274cfc8a8/node_modules/next/dist/client/app-dir/link.js");
;
import(/* webpackMode: "eager", webpackExports: ["AccordionHeader"] */ "/opt/build/repo/packages/react/src/accordion/header/AccordionHeader.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["AccordionItem"] */ "/opt/build/repo/packages/react/src/accordion/item/AccordionItem.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["AccordionPanel"] */ "/opt/build/repo/packages/react/src/accordion/panel/AccordionPanel.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["AccordionRoot"] */ "/opt/build/repo/packages/react/src/accordion/root/AccordionRoot.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["AccordionTrigger"] */ "/opt/build/repo/packages/react/src/accordion/trigger/AccordionTrigger.tsx");
